export const SUBSCRIBE_REQUEST = 'SUBSCRIBE_REQUEST';
export const SUBSCRIBE_SUCCESS = 'SUBSCRIBE_SUCCESS';
export const SUBSCRIBE_FAILURE = 'SUBSCRIBE_FAILURE';
export const SUBSCRIBE_RESET = 'SUBSCRIBE_RESET';

export const subscribeEmail = (payload) => ({ type: SUBSCRIBE_REQUEST, payload });
export const resetSubscribe = () => ({ type: SUBSCRIBE_RESET });
